import { useState } from "react";
import {
  fetchCurrencies,
  createCurrency,
  updateCurrency,
  deleteCurrency as deleteCurrencyApi,
  getCurrencies,
} from "../../../api/currency.api";

export const useCurrency = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadCurrencies = async () => {
    setLoading(true);
    const res = await getCurrencies();
    setData(res.data || []);
    setLoading(false);
  };

  const addCurrency = (payload) => createCurrency(payload);
  const editCurrency = (id, payload) =>
    updateCurrency(id, payload);

  const deleteCurrency = async (id, payload) => {
    const res = await deleteCurrencyApi(id, payload);
    return res.data;
  };

  return {
    data,
    loading,
    loadCurrencies,
    addCurrency,
    editCurrency,
    deleteCurrency,
  };
};
